module.exports = __webpack_public_path__ + "static/img/logo14.871d7c96.png";